export const NAVIGATION_TABS = [
  "event log",
  "overview",
  "day-time",
  "night-time",
  "sustenance",
  "independence",
  "temperature",
  "bathroom",
  "devices",
];
